import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposRacasCores } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposRacasCores() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_RACAS_CORES, paginaPermissao: FUNCIONALIDADES.TIPOS_RACAS_CORES, rota: ROUTES.TIPOS_RACAS_CORES, fetchData: function (str, _, pag) { return getTiposRacasCores(str, pag); }, columns: COLUNAS }));
}
